<loading-spinner></loading-spinner>
<div class="" id="fleet-portal" [ngClass]="isFullwidth ? 'full-width-content' : 'wrapper'">
  <!-- [class.full-width-content]="isFullwidth" -->
  <fleet-header [whiteHeaderUserPanel]="isWhiteHeaderUserMenu"></fleet-header>
  <main class="content">
    <router-outlet></router-outlet>
  </main>
  <fleet-footer></fleet-footer>
</div>

<space-modal-land-platform [brand]="'cs'"></space-modal-land-platform>